<template>
  <div class="container form-page">
    <base-form/>
  </div>
</template>

<script>
import BaseForm from "./BaseForm.vue";

export default {
  name: "CreateForm",
  components: {BaseForm},
}
</script>

<style scoped>
.form-page {
  width: 100%;
  max-width: 1140px;
  padding-top: 8px;
  padding-bottom: 24px;
}
</style>
